import { Button, Typography } from "@mui/material";
import { DateTime } from "luxon";
import {
  getFloorPlanByWorkplaceInventoryId,
  getFloorPlanByZoneInventoryId
} from "../../utils/axios-requests";
import { EquipmentStatus } from "../../features/FloorManager/typings/svg.types";

interface P {
  params: {
    placeInventoryId?: number | null;
    zoneInventoryId?: number | null;
    floorName?: string;
    locationName?: string;
    status?: EquipmentStatus | string;
  };
  noPlaceButtonText: string;
  showButtonText: string;
  type?: "Equipment" | "Other";
  setSelectedInventoryId: (scheduleId: number) => void;
  setFloorPlan: (r: any) => void;
  setOpen: (bool: boolean) => void;
  setDialogTitle?: (title: string) => void;
}

const ShowAssignedFloor = ({
  params,
  noPlaceButtonText,
  showButtonText,
  type = "Other",
  setSelectedInventoryId,
  setFloorPlan,
  setOpen,
  setDialogTitle
}: P) => {
  const { placeInventoryId, zoneInventoryId } = params;

  // fetch the floor plan by its inventory id and show floor plan modal
  const showFloorByInventoryId = (): void => {
    // when the item is place
    if (placeInventoryId && placeInventoryId !== null) {
      setSelectedInventoryId(placeInventoryId);
      setDialogTitle?.("Assigned Place");
      getFloorPlanByWorkplaceInventoryId(placeInventoryId, {
        start: DateTime.now().toISO(),
        end: DateTime.now().plus({ minutes: 1 }).toISO()
      }).then(r => {
        setFloorPlan(r.data);
        setOpen(true);
      });
    }

    // when the item is zone
    if (zoneInventoryId && zoneInventoryId !== null) {
      setSelectedInventoryId(zoneInventoryId);
      setDialogTitle?.("Assigned Room");
      getFloorPlanByZoneInventoryId(zoneInventoryId, {
        start: DateTime.now().toISO(),
        end: DateTime.now().plus({ minutes: 1 }).toISO()
      }).then(r => {
        setFloorPlan(r.data);
        setOpen(true);
      });
    }
  };

  const isAssigned = params.floorName && params.locationName;
  const isEquipmentShowButton =
    type === "Equipment" && (params.status === EquipmentStatus.PLACED || EquipmentStatus.BOOKED);
  const isOtherShowButton =
    type === "Other" && (placeInventoryId !== null || zoneInventoryId !== null);
  const isShowButton = (isEquipmentShowButton || isOtherShowButton) && isAssigned;

  return (
    <>
      {/* when the item is not assigned */}
      {!isAssigned && (
        <Typography
          component="span"
          variant="body2"
          color="text.secondary"
          data-testid={`${noPlaceButtonText}-btn`}
        >
          {noPlaceButtonText}
        </Typography>
      )}

      {/* when the item is assigned */}
      {isShowButton && (
        <Button data-testid={"show-assigned-floor"} onClick={showFloorByInventoryId} size={"small"}>
          {showButtonText}
        </Button>
      )}
    </>
  );
};

export default ShowAssignedFloor;
